import faker from "@faker-js/faker";
import React from "react";
import Member from "../../components/Member/Member";
import { strings } from "../../strings";
import styles from "./TeamSection.module.scss";
import member1 from "../../assets/IMG_6853.PNG.png";
import member2 from "../../assets/IMG_6867.PNG.png";
import member3 from "../../assets/member3.png";
import member4 from "../../assets/member4.png";
import member5 from "../../assets/member5.png";
import member6 from "../../assets/member6.png";
import member7 from "../../assets/member7.png";
import member8 from "../../assets/member8.png";
import { isBrowser, isMobile, isTablet } from "react-device-detect";

export default function TeamSection() {
  const members = [
    {
      id: 0,
      name: "Wayne Snow",
      img: member1,
      description: "Neo soul artist<br/>with 27 million streams",
      socials: {
        spotify:
          "https://open.spotify.com/artist/4f44GWlEQdXaWl8gQ9sPBC?si=99gcEeMzQTmhGWgtFgSu8g",
        instagram: "https://www.instagram.com/waynesnowmusic/",
      },
    },
    {
      id: 1,
      name: "Konstantin Kofta",
      img: member2,
      description:
        "Designer and CEO at<br/><a href='https://www.instagram.com/koftastudio/'>@koftastudio</a>",
      socials: {
        web: "https://koftastudio.com/collections/couture",
        instagram: "https://instagram.com/koftastudio?utm_medium=copy_link",
      },
    },
    {
      id: 2,
      name: "Bryan Georges",
      img: member3,
      description: "iiNDYVERSE<br/>Co-Founder & CEO",
      socials: {
        linkedin: "https://www.linkedin.com/in/bryangeorges/",
        twitter: "https://twitter.com/iindyverse",
      },
    },
    {
      id: 3,
      name: "Robin Shaw",
      img: member4,
      description: "iiNDYVERSE<br/>Co-Founder & CMO",
      socials: {
        linkedin: "https://www.linkedin.com/in/robin-shaw-a0876129/",
        twitter: "https://twitter.com/iindyverse",
      },
    },
    {
      id: 4,
      name: "Rev Miller",
      img: member5,
      description: "Co-Founder @ Atlantis World,<br/>Adoption Lead @ Witnet",
      socials: {
        linkedin: "https://www.linkedin.com/in/revmiller/",
        twitter: "https://twitter.com/revrfg",
      },
    },
    {
      id: 5,
      name: "Mark Sugden",
      img: member6,
      description: "Business Development and<br/>Partnerships at NEAR",
      socials: {
        linkedin: "https://www.linkedin.com/in/msugden/",
        twitter: "https://twitter.com/nakameowdough",
      },
    },
    {
      id: 6,
      name: "Niko Seizov",
      img: member7,
      description: "Starling Works<br/>Artist Manager",
      socials: {
        linkedin: "https://www.linkedin.com/in/nseizov/",
        web: "https://www.starling.works/",
      },
    },
    {
      id: 7,
      name: "Valentina Palange",
      img: member8,
      description: "Starling Works<br/>Artist Manager",
      socials: {
        linkedin: "https://www.linkedin.com/in/valentina-palange/",
        web: "https://www.starling.works/",
      },
    },
  ];
  console.log(isMobile, isTablet, isBrowser, "ISMOVILE");
  return (
    <div id="team" className={styles.wrapper}>
      <h4 className={styles.teamHeader}>{strings.teamHeader}</h4>
      {isBrowser ? (
        <>
          <div className={styles.teamMembers}>
            {JSON.parse(JSON.stringify(members))
              .slice(0, 4)
              .map((member) => (
                <Member key={member.id} {...member} />
              ))}
          </div>
          <div className={styles.teamMembers}>
            {JSON.parse(JSON.stringify(members))
              .slice(4)
              .map((member) => (
                <Member key={member.id} {...member} />
              ))}
          </div>
        </>
      ) : (
        <div className={styles.teamMembers}>
          {members.map((member) => (
            <Member key={member.id} {...member} />
          ))}
        </div>
      )}
    </div>
  );
}
